import { IGoal, IResponseGoal } from "features/onboarding/types"

const convertResponseToClientGoal = (responseGoal: IResponseGoal): IGoal => {
  return {
    caloriesPerDay: responseGoal.caloriePerDay,
    newCaloriesPerDay: responseGoal.newCaloriePerDay,
    protein: responseGoal.pfcBalance.protein,
    fat: responseGoal.pfcBalance.fat,
    carb: responseGoal.pfcBalance.carb,
    height: responseGoal.height,
    weight: responseGoal.weight,
    targetWeight: responseGoal.targetWeight,
    weightChangePerWeek: responseGoal.weightChangePerWeek,
    typeName: responseGoal.typeName,
    reachedOn: responseGoal.reachedOn,
    bmr: responseGoal.bmr,
    startDate: responseGoal.startedAt,

    proteinGram: responseGoal.pfc.protein,
    fatGram: responseGoal.pfc.fat,
    carbsGram: responseGoal.pfc.carb,
    shouldShowWeightChangedNotification: responseGoal.showBodyChanged,
    isCustomized: responseGoal.isCustomized,
    modelMesh: responseGoal.modelMesh,
  }
}

export default convertResponseToClientGoal
